<div class="grid grid-nogutter h-screen">
  <div class="col-12 sm:col-12 md:col-6 lg:col-9 bg-primary sm-d-none">
    <div class="bg"></div>
    <!-- <img src="../../../../assets/img/login-bg-Final-3x.jpg" class=" bg-center" height="100%" width="100%" /> -->
    <!-- <img src="../../../../assets/img/flms.jpg" class=" bg-center" height="100%" width="100%" /> -->
  </div>
  <div class="col-12 sm:col-12 md:col-6 lg:col-3 jbn-login-bg-color">
    <div class="login-form">
      <div class="upper-sec-login">
        <img src="../../../../assets/img/FDS-Final.svg" width="100%" class="mb-3" />
        <!-- <p-button disabled="false" (onClick)="loginWithKeycloak()" label="Sign in with SSO"
          class="btn signin-btn my-2 w-full p-0" />
        <div class="w-full">
          <p-divider align="center" type="solid">
            <b>Or</b>
          </p-divider>
        </div> -->
        <div class="grid mt-1">
          <form #loginForm="ngForm" class="w-full m-0" (ngSubmit)="check(loginForm, 'Direct')">
            <div class="col-12 mb-0">
              <input #loginNameInput="ngModel" type="text" pInputText autocomplete="off" [(ngModel)]="username"
                placeholder="Login Name" class="form-control" id="username" name="username" required maxlength="50"
                sanitizeInput />
              <div *ngIf="
                (loginNameInput.touched || loginForm.submitted) &&
                loginNameInput.invalid
              " class="text-danger">
                <div *ngIf="loginNameInput?.errors?.['required']" class="error">
                  Login name is required.
                </div>
              </div>
            </div>
            <div class="col-12 mb-2">
              <div class="flex">
                <p-password #passwordInput="ngModel" [(ngModel)]="password" autocomplete="off" [toggleMask]="true"
                  [feedback]="false" placeholder="Password" class="form-control p-0" id="password" name="password"
                  required />
              </div>
              <div *ngIf="
                (passwordInput.touched || loginForm.submitted) &&
                passwordInput.invalid
              " class="text-danger">
                <div *ngIf="passwordInput?.errors?.['required']" class="error">
                  Password is required.
                </div>
              </div>
            </div>
            <div class="grid padding-hlaf mb-0">
              <div class="col-5">
                <p-inputGroup class="relative">
                  <input type="text" pInputText (copy)="(false)" [value]="captchasum.question" class="form-control"
                    [readOnly]="true" />
                  <button type="button" icon="pi pi-sync" pButton class="btn refresh-btn"
                    (click)="generateCaptcha()"></button>
                </p-inputGroup>
              </div>
              <div class="col-1">=</div>
              <div class="col-6">
                <input #captchaInput="ngModel" type="text" (paste)="(false)" (drop)="(false)" pInputText required
                  [(ngModel)]="captcha" placeholder="Enter Captcha" class="form-control" id="captcha" name="captcha"
                  maxlength="6" />
                <div *ngIf="
                (captchaInput.touched || loginForm.submitted) &&
                captchaInput.invalid
              " class="text-danger">
                  <div *ngIf="captchaInput?.errors?.['required']" class="error">
                    Captcha is required.
                  </div>
                </div>
                <!-- <div *ngIf="loginForm.submitted" class="text-danger">
              <div *ngIf="captcha !== captchaString">Invalid Captcha.</div>
            </div> -->
              </div>
            </div>

            <!-- <div class="grid padding-hlaf">
              <div class="col-6">
                <p-button label="LDAPS Login" icon="pi pi-arrow-right" iconPos="right" (onClick)="check(loginForm,'LDAPS')"
                  class="btn login-btn mb-2 mt-2 w-full p-0" />
              </div> 
              <div class="col-12">
                <p-button label="Sign In" (onClick)="check(loginForm, 'Direct')"
                  class="btn login-btn mb-2 mt-2 w-full p-0" />
              </div>
              <p-button label="Get Support" class="btn signin-btn my-2 w-full p-0" (click)="openMailClient()" />
            </div>  -->
            <div class="grid login-buttons">
              <div class="col-12">
                <p-button label="Sign In" type="submit" [loading]="isLoginLoading" [disabled]="isLoginLoading"
                  class="btn login-btn mb-2 mt-2 w-full p-0" />
                <p-button label="Get Support" class="btn signin-btn my-2 w-full p-0" (click)="openMailClient()" />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="relative bottom-0 left-0 w-full bottom-sec-login">

        <img src="../../../../assets/img/JBN-Final.svg" width="100%" class="mt-5" />
        <div class="copy-rights">Copyrights©{{ dateyear }} v{{ version$ | async }}</div>

      </div>

    </div>
  </div>
</div>
<p-dialog [modal]="true" position="center" [(visible)]="visible" [style]="{ width: '30vw' }" [draggable]="false"
  [resizable]="false" [closable]="false">
  <ng-template pTemplate="header">
    <div class="inline-flex align-items-center justify-content-center gap-2">
      <span class="white-space-nowrap">Confirmation</span>
    </div>
  </ng-template>
  <p>{{ otherDeviceResponse }}</p>
  <!-- <p>It seems you have already login </p> -->

  <ng-template pTemplate="footer">
    <p-button class="yes" (click)="visible = false" label="Yes" pAutoFocus [autofocus]="true"
      (click)="confirm()"></p-button>
    <p-button class="no " (click)="visible = false" label="No" pAutoFocus [autofocus]="true"
      (click)="onCancel()"></p-button>
    <!-- <p-button icon="pi pi-times" severity="secondary" (click)="visible = false" label="clear active session" pAutoFocus
      [autofocus]="true"></p-button> -->
  </ng-template>
</p-dialog>